import { createSlice } from "@reduxjs/toolkit";
import { api } from "../api";

const initialState = {};

export const edgesSlice = createSlice({
  name: "edges",
  initialState,
  reducers: {
    addEdge(state, action) {
      return action.payload;
    },
    removeEdge(state, action) {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    /** By Default, on builder data field set simple  */
    builder.addMatcher(
      api.endpoints.getBuilderData.matchFulfilled,
      (state, { payload }) => {
        const { kantprofilers } = payload.selected;
        state = {
          ...kantprofilers
        };
        return state;
      }
    );
  },
});

/** Actions */
export const { addEdge, removeEdge } = edgesSlice.actions;

/** Selectors */
export const getEdges = (store) => store.edges;
